import React from 'react';
import { MiniButton } from '@yme/atoms/mini-button';
import { ForwardBtnWithAnimation } from '@yme/molecules/buttons/ForwardBtnWithAnimation';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { ReadMoreLinkStyled } from '../styled';
export function ReadMoreButton({ toRoute, linkTarget, isRightToLeft, onClickHandler, contentColor = colorCoreBlack900Base, labelLink, dataTestId, }) {
    return (React.createElement(ReadMoreLinkStyled, { to: toRoute, target: linkTarget, isRightToLeft: isRightToLeft, lineColor: contentColor, "data-testid": dataTestId },
        React.createElement(MiniButton, { isRightToLeft: isRightToLeft, contentColor: contentColor, onClick: onClickHandler, isPaddingsReset: true, as: "span" }, labelLink),
        React.createElement(ForwardBtnWithAnimation, { color: contentColor, isRightToLeft: isRightToLeft })));
}
